export const recommendedSearchTileSelector = (state) => state.searchTile.recommendedResult;

export const searchTileSelector = (state) => state.searchTile.searchTileResult;
export const dashboardContentSelector = (state) => state.searchTile.dashboardContent;
export const dashboardEventSelector = (state) => state.searchTile.dashboardEvent;



// WEBPACK FOOTER //
// ./src/state/modules/search-tile/selectors.js